module.exports = __webpack_public_path__ + "img/icon-sb-clock-orange-24x24.bbc5e9d.svg";